// Getters
export const NEW_FRANCHISE_MANUAL_SIDEBAR = 'franchise_manual/NEW_FRANCHISE_MANUAL_SIDEBAR'
export const PUBLISH_MANUAL_VERSION_SIDEBAR = 'franchise_manual/PUBLISH_MANUAL_VERSION_SIDEBAR'
export const FRANCHISE_MANUALS_SEARCH_RESULT = 'franchise_manual/FRANCHISE_MANUALS_SEARCH_RESULT'
export const MY_FRANCHISE_MANUAL_CYCLE = 'franchise_manual/MY_FRANCHISE_MANUAL_CYCLE'

// Mutations
export const MUTATE_NEW_FRANCHISE_MANUAL_SIDEBAR = 'franchise_manual/MUTATE_NEW_FRANCHISE_MANUAL_SIDEBAR'
export const MUTATE_PUBLISH_MANUAL_VERSION_SIDEBAR = 'franchise_manual/MUTATE_PUBLISH_MANUAL_VERSION_SIDEBAR'
export const MUTATE_FRANCHISE_MANUALS_SEARCH_RESULT = 'franchise_manual/MUTATE_FRANCHISE_MANUALS_SEARCH_RESULT'
export const MUTATE_MY_FRANCHISE_MANUAL_CYCLE = 'franchise_manual/MUTATE_MY_FRANCHISE_MANUAL_CYCLE'

// Actions
export const OPEN_NEW_FRANCHISE_MANUAL_SIDEBAR = 'franchise_manual/OPEN_NEW_FRANCHISE_MANUAL_SIDEBAR'
export const OPEN_PUBLISH_MANUAL_VERSION_SIDEBAR = 'franchise_manual/OPEN_PUBLISH_MANUAL_VERSION_SIDEBAR'
export const CREATE_FRANCHISE_MANUAL = 'franchise_manual/CREATE_FRANCHISE_MANUAL'
export const UPDATE_FRANCHISE_MANUAL = 'franchise_manual/UPDATE_FRANCHISE_MANUAL'
export const PUBLISH_FRANCHISE_MANUAL_VERSION = 'franchise_manual/PUBLISH_FRANCHISE_MANUAL_VERSION'
export const GET_FRANCHISE_MANUAL = 'franchise_manual/GET_FRANCHISE_MANUAL'
export const SEARCH_FRANCHISE_MANUALS = 'franchise_manual/SEARCH_FRANCHISE_MANUALS'
export const TOGGLE_FRANCHISE_MANUAL_STATUS = 'franchise_manual/TOGGLE_FRANCHISE_MANUAL_STATUS'
export const GET_FRANCHISE_CONTRACT_TYPE_OPTIONS = 'franchise_manual/GET_FRANCHISE_CONTRACT_TYPE_OPTIONS'
export const GET_MY_FRANCHISE_MANUAL_CYCLE = 'franchise_manual/GET_MY_FRANCHISE_MANUAL_CYCLE'
export const CONFIRM_FRANCHISE_MANUAL_RECEIPT = 'franchise_manual/CONFIRM_FRANCHISE_MANUAL_RECEIPT'
export const CONFIRM_FRANCHISE_MANUAL_READING = 'franchise_manual/CONFIRM_FRANCHISE_MANUAL_READING'
export const SEARCH_FRANCHISE_MANUAL_COMPLIANCE = 'franchise_manual/SEARCH_FRANCHISE_MANUAL_COMPLIANCE'
export const GET_FRANCHISE_MANUAL_HISTORY = 'franchise_manual/GET_FRANCHISE_MANUAL_HISTORY'
